import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlusCircle, Image as ImageIcon, Video, Clapperboard, PenSquare } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import CreateReelDialog from "@/components/CreateReelDialog";

/** "Criar" menu (desktop + mobile nav): Foto · Vídeo · Reel · Publicação */
export default function CreateMenu({ trigger }) {
  const navigate = useNavigate();
  const [reelOpen, setReelOpen] = useState(false);
  const go = (kind) => navigate(`/feed?compose=${kind}&t=${Date.now()}`);
  const items = [
    { key: "photo", label: "Foto", desc: "Publique uma ou mais fotos", icon: ImageIcon, color: "text-green-600", onClick: () => go("photo") },
    { key: "video", label: "Vídeo", desc: "Vídeo no feed", icon: Video, color: "text-purple-600", onClick: () => go("video") },
    { key: "reel", label: "Reel", desc: "Vídeo curto com música", icon: Clapperboard, color: "text-pink-600", onClick: () => setReelOpen(true) },
    { key: "post", label: "Publicação", desc: "Texto, link, enquete...", icon: PenSquare, color: "text-blue-600", onClick: () => go("text") },
  ];
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-60" data-testid="create-menu">
          <DropdownMenuLabel className="text-xs text-muted-foreground flex items-center gap-1"><PlusCircle className="w-3.5 h-3.5" /> O que você quer criar?</DropdownMenuLabel>
          {items.map((it) => (
            <DropdownMenuItem key={it.key} onClick={it.onClick} data-testid={`create-${it.key}`} className="gap-3 py-2.5">
              <span className={`w-9 h-9 rounded-xl bg-muted flex items-center justify-center ${it.color}`}><it.icon className="w-4 h-4" /></span>
              <span><span className="block text-sm font-semibold">{it.label}</span><span className="block text-[11px] text-muted-foreground">{it.desc}</span></span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <CreateReelDialog open={reelOpen} onOpenChange={setReelOpen} onCreated={(p) => navigate(`/reels?start=${p.post_id}`)} />
    </>
  );
}
